/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable camelcase */
/*
Metadata Label configurator
Call back will tests conditions to define
If value is available or 'Unavailable'
*/
import filesize from 'filesize';
import distance from '@turf/distance';
import { ExifMetaDataItem, MetadataBuilder } from './photo-metadata-viewer';

const metadataConfig: ExifMetaDataItem[] = [
  {
    label: 'Date:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      const timestamp = exif.date_time_original || exif.date_time;
      if (timestamp != null) {
        const [date, fullTime] = timestamp.split('T');
        const time = fullTime ? fullTime.split('.')[0] : '';
        return `${date}  ${time}`;
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Make/Model:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.make || exif.model) {
        return [exif.make, exif.model].join(' ');
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Software:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.software != null) {
        return exif.software;
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Dimensions:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.pixel_x_dimension != null && exif.pixel_y_dimension != null) {
        const pixels = ((+exif.pixel_x_dimension * +exif.pixel_y_dimension) / 1000000).toFixed(1);
        return `${exif.pixel_x_dimension} x ${exif.pixel_y_dimension} (${pixels}MP)`;
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Size:',
    value: (
      rawMetadata: MetadataBuilder,
    ): string => {
      const { file_size } = rawMetadata.photoMetadata;
      if (file_size != null) {
        return String(filesize(+file_size, { round: 0 }));
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Latitude:',
    value: (
      rawMetadata: MetadataBuilder,
    ): string => {
      const { latitude } = rawMetadata.photoMetadata;
      if (latitude != null && latitude !== 0) {
        return String(latitude.toFixed(6));
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Longitude:',
    value: (
      rawMetadata: MetadataBuilder,
    ): string => {
      const { longitude } = rawMetadata.photoMetadata;
      if (longitude != null && longitude !== 0) {
        return String(longitude.toFixed(6));
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Accuracy:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.gps_dop) {
        return String((+exif.gps_dop).toFixed(1));
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Altitude:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.gps_altitude) {
        return `${(+exif.gps_altitude).toFixed(1)}m`;
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Direction:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      if (exif.gps_img_direction) {
        return `${(+exif.gps_img_direction).toFixed(0)}°`;
      }
      return 'Unavailable:';
    },
  },
  {
    label: 'Distance:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { exif } = rawMetadata.photoMetadata;
      const { latitude } = rawMetadata.record;
      const { longitude } = rawMetadata.record;

      if (
        exif.gps_longitude
        && exif.gps_latitude
        && latitude != null
        && latitude !== 0
        && longitude != null
        && longitude !== 0
      ) {
        const photoPoint = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [Number(longitude), Number(latitude)],
          },
        };
        const recordPoint = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [Number(exif.gps_longitude), Number(exif.gps_latitude)],
          },
        };

        const units = 'kilometers';
        // @ts-ignore
        const dist = distance(photoPoint, recordPoint, units) * 1000;
        return String(`${dist.toFixed(1)}m`);
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Labels:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { labels } = rawMetadata.photoMetadata;
      if (labels) {
        const labelValues = labels.labels.map((object: { name: string; }) => object.name);
        return labelValues.join(', ');
      }
      return 'Unavailable';
    },
  },
  {
    label: 'Text:',
    value: (
      rawMetadata: MetadataBuilder,
    ) => {
      const { text } = rawMetadata.photoMetadata;
      if (text) {
        const textValues = text.text_detections
          .map((object: { detected_text: string; }) => object.detected_text);
        return textValues.join(', ');
      }
      return 'Unavailable';
    },
  },
];
export default metadataConfig;
